// ESM-Huelle fuer lib/scripts/pos/components/messageboard.js (ESM-Welle 5a).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.

function messageboard(){
		console.log('in messageboard');
		this.posid = 0;
		this.userid= 0;
}


messageboard.prototype.init = function(posid,userid){
	
	if (posid){
		this.posid=posid;
	}
	if (userid){
		this.userid=userid;
	}
	var mbme= this;
	var tabs= $('<div id="mbtabs" class="ui-tabs ui-corner-all ui-widget ui-widget-content" style="">\
			  <ul role="tablist" class="ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header">\
				<li><a href="#tabs-1">Allgemein</a></li>'+
				mbme.options.tabtext_filiale+mbme.options.tabhtml_person+
				'<li><a href="#tabs-4">Gesendet</a></li>\
			  </ul>\
		  <div id="tabs-1"></div>\
		  <div id="tabs-2"></div>\
		  <div id="tabs-3"></div>\
		  <div id="tabs-4"></div>\
		</div>');
	tabs.appendTo($('body'));
	$("#mbtabs").tabs();
    $("#mbtabs").tabs({
        activate: function(event, ui) {
            console.log();
            if (event.currentTarget.hash == '#tabs-1') { //Tabelle
                //show_loading_message();
				mbme.remove();
                //remove_tables(true);
				mbme.loadMessageTopics(null,999999,null,"mbtabs", 1);
                //hide_loading_message();
            } else if (event.currentTarget.hash == '#tabs-2') { 
                //			window.forms[window.currentform].function(window.forms[window.currentform]);
                //show_loading_message();
                //remove_tables(true);
				mbme.remove();
				mbme.loadMessageTopics(null,null,mbme.posid,"mbtabs",2);
                //hide_loading_message();
            } else if (event.currentTarget.hash == '#tabs-3') { 
                //			window.forms[window.currentform].function(window.forms[window.currentform]);
                //show_loading_message();
                //remove_tables(true);
				mbme.remove();
				mbme.loadMessageTopics(null,mbme.userid,null,"mbtabs",3);
                //hide_loading_message();
            }  else if (event.currentTarget.hash == '#tabs-4') { 
                //			window.forms[window.currentform].function(window.forms[window.currentform]);
                //show_loading_message();
                //remove_tables(true);
				mbme.remove();
				mbme.loadMessageTopics(mbme.userid,null,mbme.posid,"mbtabs",4);
                //hide_loading_message();
            }

        }
    });
	
	if (mbme.options.isPOS){
		$("#mbtabs").append($('<button id="closemessages">'+mbme.options.closebuttontext+'</button>'));
	}
	$('#closemessages').click(function(){
			$("#mbtabs").remove();
	});
	
	$('a[href="#tabs-3"]').click();
	
	
}


messageboard.prototype.loadMessageTopics = function(sender,receiver, posid, parent,type){
	
	var mbme= this;
	$('.messageboard').remove();
	var tdiv=$('<div class="messageboard">').appendTo($('#'+parent));//($('#'+parent));
	$(tdiv).append($('<p></p><h1>Nachrichten</h1>'));
	$(tdiv).append($('<div class="seperator"></div>'));
	$(tdiv).append($('<div class="modal-footer">\
					<button type="button" class="btn btn-default modalclose" data-dismiss="modal">'+mbme.options.closebuttontext+'</button>\
					<button type="button" class="btn btn-default new" data-dismiss="modal">Neue Nachricht</button>\
	</div>'));
	$(tdiv).append($('<div class="seperator"></div>'));
	var del ='<th>Löschen</th>';
	var sendrecv = '<th>Von</th>';
	if ((mbme.options.isPOS) && (type<3)){ //gensendet + persönlich
		del='';
	}
	var seen ='';
	//if (!(mbme.options.isPOS) && (type==4)){
		seen ='<th>Gelesen</th>';
//	}
	if (type==4){
		sendrecv= '<th>An</th>';
	}
	
	var t=($('<table class="messagetable" ><thead><tr><th>ID</th><th>Betreff</th><th>Datum</th>'+sendrecv+seen+del+'</tr></thead><tbody>'));
	$(tdiv).append(t);
	
	var showTopics= function(result){
		if (result){
			for (var i=0;i<result.length;i++){
				var delbutton = '<td><button class="delete_message_button" postid="'+result[i].id+'">Löschen</button></td>';
				if ((mbme.options.isPOS) && (type<3)){ //gensendet + persönlich
					delbutton = '';
				}
				var seen = "";
	//			if (!(mbme.options.isPOS) && (type==4)){
					var s = result[i].seen?result[i].seen:result[i].has_read;
					s = s?s:0; 
					seen ='<td nowrap>'+s+'</td>';
	//			}
				if (type<4){
					var von = (result[i].owner >= 0)?result[i].owner:('POS_'+result[i].posid_sent);
					if (von ==Number(0) || von=='POS_0'){
						von = 'Zentrale';
					}
					var anvon='<td nowrap>'+von+'</td>'; //von
				} else { //Gesnedet
					var an = (result[i].receiver>=0)?result[i].receiver:('POS_'+result[i].posid_recv);
					if ((Number(an) == 999999) || (Number(an) == 999998)){
						an= "Alle";
					} else if (Number(an) == 0){
						an="Zentrale";
					}
					anvon='<td nowrap>'+an+'</td>'; //an

				}
	
				t.append($('<tr type="'+type+'" postid="'+result[i].id+'"><td nowrap>'+result[i].id+'</td><td nowrap>'+result[i].object+'</td><td nowrap>'+
				result[i].create_time.replace('T',' ')+
				'</td>'+anvon+seen+delbutton+'</tr>'));
			}
		t.append($('</tbody></table>'));
		t.find('tr').click(function(e){
			var s = POS.sessions.currentSession;
                        var main = POS.sessions.openSessions[s];
                        main.InfoIcons.hideIcon("email");
			var id = $(e.currentTarget).attr('postid');
			var t = $(e.currentTarget).attr('type');
			mbme.readMessage(id,t);
		})
		
		$('.delete_message_button').click(function(e){
			var messageid= $(this).attr('postid');
			t.find('tr[postid='+messageid+']').remove();
			var sql = "DELETE from messageboard.posts where id="+messageid;
			mbme.queryDB('mysql',sql);
		});
		
	}
	}
	$(tdiv).append($('<div class="seperator"></div>'));
	
	
		$('.messageboard').find('.new').click(function(){
			mbme.newMessage(mbme, type);				
		});
		
		$('.messageboard').find('.modalclose').click(function(){
				$('.messageboard').remove();
				return false;
		});
			
		var d = new Date();
		d.setFullYear( d.getFullYear() - 1 );
		var newDate = new Date(d.getTime() - d.getTimezoneOffset()*60*1000);
		var date = newDate.toISOString().substring(0,19);

	if (type==4){//sent
		var sql = "SELECT *,count(POS_ID) as seen from messageboard.posts left join messageboard.messages_read on message_id=id where (owner="+sender+
		" or  posid_sent="+mbme.posid+") and (create_time>'"+date+
		"' or permanent=1) group by id order by id desc";
	} else if (type==3)	{//personal
		sql = "SELECT * from messageboard.posts where receiver="+receiver+" and (create_time>'"+date+"' or permanent=1) order by id desc";
	} else if (type==2){ //pos
		sql = "SELECT *,case when message_id>0 then 1 else 0 end as seen  from messageboard.posts left join messageboard.messages_read on (message_id=id and posid_recv="+
		mbme.posid+") where (posid_recv="+mbme.posid+")  and (create_time>'"+date+"' or permanent=1) order by id desc";
	}else { //common
		sql = "SELECT *,case when message_id>0 then 1 else 0 end as seen from messageboard.posts left join messageboard.messages_read on (message_id=id and POS_ID="+
		mbme.posid+") where (receiver=999999 or receiver=999998)  and (create_time>'"+date+"' or permanent=1) order by id desc";
	}
	this.queryDB('mysql',sql, showTopics);
}


messageboard.prototype.appendOptions=function(dd,opt,leaveOpts){
						if (!(leaveOpts))
						dd.empty();
						opt.each(function() {
								var opt = $("<option>");
								dd.append(opt);
							for (var key in this) {

								if (key=='text'){
									opt.text(this.text);
								} else {
									opt.attr(key,this[key]);
								}
							}
                         });
						//dd.combobox();
}


messageboard.prototype.createUserDropdown= function(callback, arg1, arg2, sql, me){
						if ($(".sendto option").length > 0) {
							if (callback) callback(arg1, arg2);
							return;
						}
	
					var fillCust = function(result){
									if (result){
										me.appendOptions($('.sendto'), $(result));
										$('.sendto').prepend($("<option>").attr('value', 0).text("Zentrale"));
										$('.sendto').prepend($("<option>").attr('value', 999999).text("Alle"));
										if (!(me.options.isPOS)){
											$('.sendto').combobox();				
										}
									} else {
										$('.sendto').append($("<option>").attr('value', 0).text("Zentrale"));
										if (!(me.options.isPOS)){
											$('.sendto').combobox();				
										}
									}
									if (me.options.isPOS){
									 $('.custom-combobox-input').keyboard({
										 layout: 'german-qwertz-1',
										  autoAccept: true,
										autoAcceptOnEsc: true,
												usePreview: false
									 });
									}
										if (callback) callback(arg1, arg2);
										
							}
					 if (!(me.options.isPOS)){
						if (!(sql)){
							sql="SELECT 'U_ID' as field, concat('POS_',Filial_ID) as value, Name as text,Filial_ID FROM POSysseus_Reports.C where Filial_ID IS NOT NULL group by Filial_ID \
union all \
SELECT 'U_ID' as field, U_ID as value, Name as text,'ZZZZZZZZ' as Filial_ID from U where U_ID>0 \
 order by Filial_ID,text";
						}
						me.queryDB('mysql',sql, fillCust);
					} else {
						fillCust(null);
					}
}


messageboard.prototype.createMessageDIV = function(parent, type){
	var me = this;
	$('.messageboard').remove();
	var tdiv=$('<div class="messageboard">').appendTo($('#'+parent));
	$(tdiv).append($('<div class="modal-footer">\
					<button type="button" class="btn btn-default messageclose modalclose row">'+me.options.closebuttontext+'</button>\
					<div class="row">Betreff:</div><input id="object" class="row"></input>\
					<button type="button" class="btn btn-default messageclose send row">Senden</button>\
					<select  class="btn btn-default sendto row"></select>\
					</div>'+me.options.checkbox_html));
	var content = $('<input id="textcontent" name="span" class="textedit"></input>');
	content.appendTo(tdiv);
	$(content).jqte();
	$('.messageboard').find('.send').click(function(){	
				if (!(me.options.isPOS)){
						var username=$('#_input').val();
						var to = $('.sendto option').filter(function () { return $(this).html() == username }).val();
						if (!to){
							to=username;
							posid_recv=username;
						}
					} else {
						to = $('.sendto').val();
					}
					if (to.startsWith('POS_')){
						var posid_recv=$('.sendto option').filter(function () { return $(this).attr('value')==to}).attr('filial_id');
						to = -1;
					} else {
						var posid_recv=-1;
					}
					
					var from = me.userid;
					var posid_sent = me.posid;
					
					if (type==2) {
						from=-1;
						posid_sent = me.posid;
					} else if (type==3) {
						posid_sent=-1;
						from=me.userid;
					}
					
					var content = $('.jqte_editor').html();
					var object= $('#object').val();
					
					me.sendMessage(to, from, object,content, posid_recv,posid_sent);	
	});
	
	$('.messageboard').find('.messageclose').click(function(){
				$('.messageboard').remove();
				return false;
	});
	
	if (me.options.isPOS){
	
	 $('#object').keyboard({
		 layout: 'german-qwertz-1',
		  autoAccept: true,
		autoAcceptOnEsc: true,
		usePreview: false
	 });
	 $('.jqte_editor').keyboard({
		 layout: 'german-qwertz-1',
		  autoAccept: true,
		autoAcceptOnEsc: true,

	 });
	}

	/*var kb = $('<div id="keyboard"></div>');
	kb.appendTo(tdiv);
	$('#keyboard').jkeyboard({
		layout: "german",
		input: $('.jqte_editor')
	});
	$('#keyboard').jkeyboard({
		layout: "german",
		input: $('#object')
	});	*/
	this.createUserDropdown( null, null, null, null, this);
/*	
	
	  // text that is typed when when pressing the
  // keyboard icon (actual code using .typeIn()
  // is at the bottom of this code block
  var simulateTyping = "Hello World!!1\b <3";

  // create a new language (love, awww) by copying the english language
  // file. we're doing this just for this demo, so we can add "<3" to the
  // combo regex
  $.keyboard.language.love = $.extend($.keyboard.language.en);
*/

}


messageboard.prototype.sendMessage = function(to,from,object,content, posid_recv,posid_sent){
	
				var me = this;
				var d = new Date();
				var newDate = new Date(d.getTime() - d.getTimezoneOffset()*60*1000);
				var date = newDate.toISOString().substring(0,19);
				var permanent=0;
					if ($('#resistent').length && $('#resistent').is(':checked')) {
						permanent=1;
					}
				//var posid=0;

				var printResult = function(){
					
				}

				var sql = "INSERT INTO messageboard.posts (object,post_text,create_time,owner,receiver,permanent,posid_recv,posid_sent) VALUES ('"+
				object+"','"+content+"','"+date+"',"+from+","+to+","+permanent+","+posid_recv+","+posid_sent+")";
				me.queryDB('mysql',sql, printResult);
}


messageboard.prototype.newMessage = function(mbme, type){
	mbme.createMessageDIV('mbtabs', type);

}


messageboard.prototype.readMessage = function(id, type){
	
	var mbme = this;
	this.createMessageDIV('mbtabs', type);
	
	var setText = function(result){
		$('#object').val(result[0].object);
		$('.jqte_editor').html(result[0].post_text);
		$('.jqte_editor').html(result[0].post_text);
		if ($('#resistent').length){
			if (result[0].permanent){
				$('#resistent').prop('checked', true);
			}
		}
		setTimeout(function(){
			$('#_input').attr('data',result[0].owner);
			var o = $('.sendto option').filter(function () { return $(this).val() == result[0].owner }).text();
			$('#_input').val(o);
		}, 1000);
	}
	
	var sql = "SELECT * from messageboard.posts where id="+id;
	this.queryDB('mysql',sql, setText);
	if (type!=4){
		if (type==3){//personal
			window.sql1 = "UPDATE messageboard.posts set has_read=1 where id="+id;
		} else if (type==2){ //pos
			//sql1 = "UPDATE ignore messageboard.posts set has_read=1 where id="+id";
			window.sql1 = "INSERT ignore into messageboard.messages_read (message_id,POS_ID) values ("+id+","+mbme.posid+")";
		}else { //common
			window.sql1 = "INSERT ignore into messageboard.messages_read (message_id,POS_ID) values ("+id+","+mbme.posid+")";
		}
		this.queryDB('mysql',sql1, null);
	}
	
}

messageboard.prototype.remove = function(){
	$('#messageboard').remove();
	
}
/*
messageboard.prototype.queryDB = function(url,sql, callback){
	show_loading_message();
 	$.when(new RunClient().sendQuery(sql, callback, "POSysseus_Reports")).then(function(error) {
                if (error){
                }

        })
return;
	var data = {
					"query": sql,
					"table": "t"
			 }
	var cb = function(result1,result){
		hide_loading_message();
		if (callback){
			callback(result);
		}
	}
	
	submitRequest(url, data, null, null, cb);
	
}
*/
//# sourceURL=messageboard.js

export { messageboard };
